import React from 'react';
import OtpInput from 'react-otp-input';
import styles from './otp-input.module.scss';

export interface OTPInputProps {
  value: string;
  onChange: (otp: string) => void;
  length?: number;
  onComplete?: (otp: string) => void;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  renderSeparator?: ((index: number) => React.ReactNode) | React.ReactNode;
  autoFocus?: boolean;
}

export const OTPInput: React.FC<OTPInputProps> = ({
  value,
  onChange,
  length = 6,
  onComplete,
  disabled = false,
  error = false,
  className = '',
  renderSeparator,
  autoFocus = true,
}) => {
  const handleChange = (otp: string) => {
    onChange(otp);
    
    if (otp.length === length && onComplete) {
      onComplete(otp);
    }
  };

  return (
    <div className={`${styles.otpContainer} ${className} ${error ? styles.error : ''}`}>
      <OtpInput
        value={value}
        onChange={handleChange}
        numInputs={length}
        renderInput={(props) => <input {...props} />}
        renderSeparator={renderSeparator}
        inputStyle={styles.otpInput}
        containerStyle={styles.otpInputsWrapper}
        shouldAutoFocus={autoFocus}
        inputType="number"
        skipDefaultStyles={false}
      />
    </div>
  );
};